import React from "react";
import Select from "react-select";

type BoolOption = { label: string; value: boolean };

const BOOL_OPTIONS: BoolOption[] = [
  { label: "False", value: false },
  { label: "True", value: true },
];

export type BooleanFieldProps = {
  settingVar: { variable: string; value?: unknown };
  onChange: (name: string, value: boolean) => void;
};

/**
 * Boolean building block (SCRUM-553, VariableField registry).
 * Reports a real boolean via `onChange(name, value)`, identical to the
 * legacy onChangeValueDropDown payload.
 */
export default function BooleanField({ settingVar, onChange }: BooleanFieldProps) {
  return (
    <Select
      classNamePrefix="select"
      value={BOOL_OPTIONS.filter((option) => option.value === settingVar.value)}
      name={settingVar.variable}
      options={BOOL_OPTIONS}
      onChange={(opt) => {
        if (opt) onChange(settingVar.variable, opt.value);
      }}
    />
  );
}
